export default {
  providers: ['facebook', 'twitter', 'linkedin'],
  hashtag: 'installfest',
  // use placeholders to interpolate presentation variables
  // {title} - presentation title
  message: 'Vychutnavam si prednasku: {title}',
  url: 'https://installfest.cz',
}



// WEBPACK FOOTER //
// ./src/content/installfest/addons/socialShare/presentation.js